import { render } from "./RadiologyDashboardPage.vue?vue&type=template&id=1489b7e8"
import script from "./RadiologyDashboardPage.vue?vue&type=script&lang=js"
export * from "./RadiologyDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__